// extracted by mini-css-extract-plugin
module.exports = {"headerText":"axu_ak1","doubleField":"axu_axv","firstInputField":"axu_axw","secondInputField":"axu_axx","errorContainer":"axu_axy","container":"axu_e","errorInput":"axu_ah6"};